import React from "react";
import AppMap from "./AppMap";
import { Skeleton } from "@mui/material";

export const IndiaMap: React.FC = () => {
  return false ? (
    <Skeleton variant="rectangular" width={"100%"} height={600} />
  ) : (
    <AppMap />
  );
};
